import { CoinsLabelWrapper } from './CoinsLabel.style';

export type CoinsLabelProps = {
	amount: number;
	valueLabel: string;
	valueLabelPlural?: string;
};

export const CoinsLabel = ({
	amount,
	valueLabel,
	valueLabelPlural = `${valueLabel}s`,
}: CoinsLabelProps) => {

	return (
		<CoinsLabelWrapper>
			<span>
				{amount} {amount === 1 ? valueLabel : valueLabelPlural}
			</span>
		</CoinsLabelWrapper>
	);
};
